/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { MembersInformationUpdate } from '../../models/members-information-update';
import { MembersWithoutSupplierData } from '../../models/members-without-supplier-data';

export interface UpdateMemberInformationApiV2MembersOrgPatch$Params {
  org: string;
      body: MembersInformationUpdate
}

export function updateMemberInformationApiV2MembersOrgPatch(http: HttpClient, rootUrl: string, params: UpdateMemberInformationApiV2MembersOrgPatch$Params, context?: HttpContext): Observable<StrictHttpResponse<MembersWithoutSupplierData>> {
  const rb = new RequestBuilder(rootUrl, updateMemberInformationApiV2MembersOrgPatch.PATH, 'patch');
  if (params) {
    rb.path('org', params.org, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<MembersWithoutSupplierData>;
    })
  );
}

updateMemberInformationApiV2MembersOrgPatch.PATH = '/api/v2/members/{org}';
